import { useMediaQuery } from '@mui/material'

export const SHORT_LANDSCAPE_MEDIA_QUERY = ['@media screen', '(orientation: landscape)', '(max-height: 45rem)'].join(
  ' and ',
)

export const useIsShortLandscape = () => useMediaQuery(SHORT_LANDSCAPE_MEDIA_QUERY)
